import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';

import { useTranslations } from '~/i18n/use-translations.ts';
import { getAppShellDataQueryOptions } from '~/server/app/app-shell-data-query.ts';
import { cn } from '~/utils/cn.ts';

export const Route = createFileRoute('/')({
	component: IndexPage,
});

function IndexPage() {
	const t = useTranslations();
	const { data } = useSuspenseQuery(getAppShellDataQueryOptions());
	const isAuthenticated = Boolean(data.authSession?.accessToken);

	return (
		<div className="flex min-h-screen flex-col justify-center">
			<main>
				<article className="mb-8 text-center">
					<h2 className="font-mono font-semibold text-4xl text-muted-foreground">EQITY</h2>
					<small className="mt-4 inline-block bg-primary px-2 text-primary-foreground">
						<strong>{t('landing.taglineFirst')} </strong> {t('landing.taglineMiddle')}{' '}
						<em>{t('landing.taglineLast')}</em>
					</small>
				</article>
			</main>
			<aside className="mt-4 text-center">
				<ul className="flex flex-row justify-center gap-2">
					<li key="/auth/signin">
						<Link
							className={cn(
								'bg-primary px-5 py-2.5 text-center font-medium text-sm',
								'mr-2 mb-2 inline-flex items-center rounded-lg',
								'text-primary-foreground focus:outline-hidden focus:ring-4 focus:ring-[#F7BE38]/50',
								'hover:bg-primary/80',
							)}
							search={isAuthenticated ? undefined : { redirectTo: undefined }}
							to={isAuthenticated ? '/dashboard' : '/auth/signin'}
						>
							{t('landing.openApp')}
						</Link>
					</li>
				</ul>
				<br />
			</aside>
		</div>
	);
}
